import React from 'react';
import PropTypes from 'prop-types';
import Container from '../../layout/Container/Container';
import Row from '../../layout/Row/Row';
import Column from '../../layout/Column/Column';
import classNames from 'classnames';
/**
 * A component for displaying landing page information
 */
function HeroSearch({ classes, children }) {
  const heroSearchClasses = classNames('hero-search', classes ? classes : []);

  return (
    <div className={heroSearchClasses}>
      <Container>
        <Row>
          <Column md={12}>
            <div className="hero-search__content">{children}</div>
          </Column>
        </Row>
      </Container>
    </div>
  );
}

HeroSearch.propTypes = {
  /**
   * The class names
   */
  classes: PropTypes.string,
  /**
   * The nested children
   */
  children: PropTypes.node.isRequired
};

export default HeroSearch;
